import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.js";
import { ReviewerApp } from "./ReviewerApp.js";
import { ToastProvider } from "./components/ui/Toast.js";
import { TooltipProvider } from "./components/ui/Tooltip.js";
import { zainstalujRaportowanieBledow } from "./lib/clientLogs.js";
import { czyTrasaRecenzenta } from "./lib/recenzja.js";
import { ThemeProvider } from "./theme/ThemeContext.js";
import "./styles/index.css";

/**
 * Poligon design systemu (`/_ds`). Siegamy po niego WYLACZNIE przez dynamiczny import
 * w martwej galezi - Vite wycina wtedy i galaz, i caly modul. Jeden statyczny import
 * gdziekolwiek indziej wciagnalby go z powrotem do bundla produkcyjnego.
 * Pilnuje tego straznik tests/static/noDevRoutesInBundle.test.ts.
 *
 * Wybor stoi tutaj, a nie w App: tam byloby to warunkowe wyjscie przed hookami,
 * czyli zlamanie Rules of Hooks.
 */
const DesignLab = import.meta.env.DEV
  ? lazy(() => import("./dev/DesignLab.js").then((m) => ({ default: m.DesignLab })))
  : null;

/**
 * Globalne przechwytywanie bledow frontu.
 *
 * Stoi PRZED createRoot, zeby zlapac takze blad rzucony w trakcie pierwszego
 * renderowania. Wpisy ida do /api/diag/client-logs i laduja w logu serwera,
 * ale tylko przy otwartym oknie diagnostyki - zamkniete odpowiada 404, co modul
 * czyta jako "przestan probowac".
 */
// Widok recenzenta (/r/<token>) jest bez logowania, a adres niesie jego jedyny sekret. Raport bledu dolaczalby
// window.location.href, czyli token trafilby do logu serwera (gdy w tej przegladarce jest tez sesja administratora).
// Dlatego tam przechwytywania nie instalujemy.
const recenzent = czyTrasaRecenzenta(window.location.pathname);
if (!recenzent) zainstalujRaportowanieBledow();

const root = document.getElementById("root");
if (!root) throw new Error("Brak elementu #root");

// Poligon celowo omija bramke autoryzacji: jego sensem jest audyt czterech stanow
// bez backendu, bez bazy i bez danych logowania.
const poligon = DesignLab !== null && window.location.pathname === "/_ds";

/*
 * Kolejnosc opakowan jest znaczaca.
 *
 * ToastProvider stoi NAJWYZEJ, zaraz pod motywem: stos toastow lezy na --z-toast,
 * czyli nad wszystkim (TO-3), i musi przezyc zmiane trasy - potwierdzenie zapisu
 * nie moze zniknac dlatego, ze klient przeszedl do innego widoku.
 *
 * TooltipProvider trzyma JEDNA instancje dymka dla calej aplikacji (TT-3): okno
 * laski miedzy elementami liczy sie globalnie, wiec dymek per element by je zepsul.
 */
createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <TooltipProvider>
          {poligon && DesignLab ? (
            <Suspense fallback={null}>
              <DesignLab />
            </Suspense>
          ) : recenzent ? (
            // Wlasny router i wlasne trasy /r/<token>: bez bramki logowania i bez /api/auth/me.
            <ReviewerApp />
          ) : (
            <BrowserRouter>
              <App />
            </BrowserRouter>
          )}
        </TooltipProvider>
      </ToastProvider>
    </ThemeProvider>
  </StrictMode>,
);
